import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitControlRequestModel, IUnitPingResultModel } from '@apps-common/types/portal/unit-control'

export const pingUnit = async (model: IUnitControlRequestModel): Promise<IUnitPingResultModel> =>
  axios.post(`/unitcontrol/ping`, model).then((res) => res?.data?.data)

type QueryFnType = typeof pingUnit

type Props = {
  config?: QueryConfig<QueryFnType>
  model: IUnitControlRequestModel
}

export const usePingUnit = ({ config, model }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    retry: false,
    staleTime: 1000 * 60 * 60 * 24,
    queryKey: ['pingUnit', model.unitId],
    queryFn: () => pingUnit(model)
  })
